import { MDBBtn, MDBChip, MDBIcon, MDBInputGroup, MDBModalFooter } from "mdb-react-ui-kit";
import { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { formattedNumber, unFormatNumber } from "../../phonenumbers/AddRemoveNumbers";

const CampaignAddRemoveNumber = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [addNumbers, setAddNumbers] = useState([]);
    const [removeNumbers, setRemoveNumbers] = useState([]);
    const [sourceNumber, setSourceNumber] = useState([]);
    const [updatesourcedel, setUpdateSourceDel] = useState(false);
    const [searchSourceQuery, setSearchSourceQuery] = useState('');
    const [searchDetinationQuery, setSearchDetinationQuery] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const maxPhones = 49;
    const [selectedOnlyNumbers, setselectedOnlyNumbers] = useState([]);
    const navigate = useNavigate();

    const handleAdd = (number) => {
        const isRemoving = addNumbers.includes(number);
        const addList = isRemoving ? addNumbers.filter(num => num !== number) : [...addNumbers, number];
        if (!isRemoving && selectedNumbers.length + addList.length > maxPhones) {
            setErrorMessage(`The maximum limit of ${maxPhones} phone numbers have been exceeded.`);
            return;
        }
        setErrorMessage('');
        const removeNum = (removeNumbers.includes(number)) ? removeNumbers.filter(removenum => removenum !== number) : removeNumbers;
        setRemoveNumbers(removeNum);
        setAddNumbers(addList);
    };

    useEffect(() => {
        if (props.sourceNumber && props.sourceNumber.length > 0 && !updatesourcedel) {
            setAddNumbers([]);
            const nums = props.selectedNum.map((num) => num.nums);
            const updatedSourceNumber = props.sourceNumber.filter(num => !nums.includes(num));
            setSourceNumber(updatedSourceNumber);
            setUpdateSourceDel(true);
        }
    }, [props, updatesourcedel]);

    useEffect(() => {
        if (props.selectedNum && props.selectedNum.length > 0) {
            setAddNumbers([]);
            setSelectedNumbers(props.selectedNum);
            const nums = props.selectedNum.map((num) => num.nums);
            const updatedSourceNumber = props.sourceNumber.filter(num => !nums.includes(num));
            setSourceNumber(updatedSourceNumber);
        }
    
    }, [props.selectedNum, props.sourceNumber])

    const handleDelete = (number) => {
        const unformatNum = unFormatNumber(number);
        const updateAddList = addNumbers.includes(unformatNum) ? addNumbers.filter(num => unformatNum !== num) : addNumbers;
        setAddNumbers(updateAddList);
    }

    async function AddNumbers(e) {
        e.preventDefault();
        e.stopPropagation();
          if (addNumbers.length === 0) {
            setErrorMessage("Please add at least one DID.");
            return;
        }
        setErrorMessage(""); // clear previous error if any
        if (selectedNumbers.length + addNumbers.length > maxPhones) {
            setErrorMessage(`The maximum limit of ${maxPhones} phone numbers have been exceeded.`);
            return;
        }
        props.setUpdateNumbersExecuted(true);
        props.setUpdatePHNum(addNumbers);
        setAddNumbers([]);
        props.onClose();
    }
    function setSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();
        const updateNumbers = addNumbers.concat(sourceNumber.filter(num => !(addNumbers.includes(num))));
        setAddNumbers(updateNumbers);
    }



    return (
        <div>
            <div>

                <div className="position-relative mb-3">
                    <div className="form-outline">
                        <input className='form-control' type='text' placeholder='Search'
                            value={searchDetinationQuery}
                            onChange={(e) => setSearchDetinationQuery(e.target.value)}
                        />
                    </div>
                    <MDBIcon
                        fas
                        icon="search"
                        className="custom-search_icon"
                    />
                </div>


                {/* <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                  <input className='form-control' type='text' placeholder='Search'
                      value={searchDetinationQuery}
                      onChange={(e) => setSearchDetinationQuery(e.target.value)}
                  />
              </MDBInputGroup> */}
                <div className="form-group row">
                    <div className="col-12">
                        <div className="form-outlines phoneNumberheight p-0">
                            <div className="chips chips-placeholder">
                                {selectedNumbers && selectedNumbers.length > 0 && (
                                    selectedNumbers
                                        .filter(number => number.nums.toLowerCase().includes(searchDetinationQuery.toLocaleLowerCase()))
                                        .map((phone) => (
                                            <MDBChip
                                                key={phone.nums} className={`m-chip d-inline py-2 px-3 ${phone.status === 1 ? 'success' :
                                                    phone.status === 2 ? 'warning' :
                                                        (phone.status === 3 || phone.status === 4) ? 'danger' :
                                                            ''
                                                    }`}
                                            >
                                                {formattedNumber(phone.nums)}
                                            </MDBChip>
                                        ))
                                )}
                                {addNumbers && addNumbers.length > 0 && (
                                    addNumbers
                                        .filter(number => number.toLowerCase().includes(searchDetinationQuery.toLocaleLowerCase()))
                                        .map((phone) => (
                                            <MDBChip
                                                onDelete={handleDelete} className="m-chip d-inline py-2 px-3"
                                                key={phone} closeIcon size="sm">
                                                {formattedNumber(phone)}
                                            </MDBChip>
                                        ))
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div className="routing-border p-0 my-4"></div>
            {errorMessage && (
                <div className="text-danger mb-3">
                    {errorMessage}
                </div>
            )}


            <div className="position-relative">
                <div className="form-outline">
                    <input className='form-control' type='text' placeholder='Search'
                        value={searchSourceQuery}
                        onChange={(e) => setSearchSourceQuery(e.target.value)} />
                </div>
                <MDBIcon
                    fas
                    icon="search"
                    className="custom-search_icon"
                />
            </div>

            {/* <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>

              <input className='form-control' type='text' placeholder='Search'
                  value={searchSourceQuery}
                  onChange={(e) => setSearchSourceQuery(e.target.value)} />

          </MDBInputGroup> */}
            <label className="selectall pt-2 text-primary cursor-pointer " onClick={(e) => setSelectAll(e)}>
                {t("selectAll")}
            </label>
            <div className="phoneNumberheight">
                <div className="routing-numbers">
                    <div className="chips chips-placeholder">
                        {sourceNumber && sourceNumber.length > 0 && (
                            sourceNumber
                                .filter(number => number.toLowerCase().includes(searchSourceQuery.toLowerCase()))
                                .map(number => (
                                    <div
                                        className={addNumbers.includes(number) ? "numberadd-green" : "numberadd"}
                                        onClick={() => handleAdd(number)}
                                    >
                                        {(formattedNumber(number))}
                                    </div>
                                ))
                        )}
                    </div>
                </div>
            </div>
            {/* <MDBModalFooter>
              {addNumbers && addNumbers.length > 0 && (<>
                  <MDBBtn color="secondary" onClick={props.onClose}>
                      {t("close")}
                  </MDBBtn>
                  <MDBBtn onClick={(e) => AddNumbers(e)}>{props.sendText ?? t("add")}</MDBBtn>
              </>)}
          </MDBModalFooter> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => AddNumbers(e)}>
                    {t("add")}</button>
            </div>

        </div>
    );
});

export default CampaignAddRemoveNumber;